import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, functions } from '../../firebase';
import { httpsCallable } from 'firebase/functions';
import { signInWithPopup, GoogleAuthProvider, FacebookAuthProvider, TwitterAuthProvider } from 'firebase/auth';
import axios from 'axios';
import { LinkedIn } from 'react-linkedin-login-oauth2';
import { FaGoogle, FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

import './Login.css';

const Login = () => {
  const { t } = useTranslation(); // Hook para traducciones
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // Estado de carga

  const apiUrl = process.env.REACT_APP_API_URL;

  const signInWithProvider = async (provider) => {
    setIsLoading(true); // Mostrar la barra de carga
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
  
      try {
        var userUID = user.uid ? user.uid : localStorage.getItem("userUID")
        await axios.get(`${apiUrl}/collections/user/${userUID}`);
        console.log("El usuario ya existe, ya tiene mail de bienvenida")
      } catch (error) {
        if (error.response && error.response.status === 404) {
          console.log("Mandando mail de bienvenida");
          await sendWelcomeMail(user.email, user.displayName);
        } else {
          console.error("Error fetching data:", error);
        }
      }
  
      // Guardar el usuario en la base de datos
      await saveUserToDatabase({
        uid: user.uid ? user.uid : localStorage.getItem("userUID"),
        email: user.email || `${user.uid}@temp.com`,
        displayName: user.displayName,
        photoURL: user.photoURL,
        hasWelcomeMail: true
      });
  
      navigate('/dashboard');
      //window.location.reload()
    } catch (error) {
      console.error('Error en la autenticación:', error);
    } finally {
      setIsLoading(false); // Ocultar la barra de carga
    }
  };
  

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const code = urlParams.get('code');
  //   if (code) {
  //     handleLinkedInSuccess(code);
  //   }
  // }, []);

  const signInWithGoogle = () => signInWithProvider(new GoogleAuthProvider());
  const signInWithFacebook = () => signInWithProvider(new FacebookAuthProvider());

  const signInWithTwitter = () => {
    const provider = new TwitterAuthProvider();
    provider.setCustomParameters({
      'include_email': 'true'
    });
    return signInWithProvider(provider);
  };

  const signInWithLinkedin = () => {
    const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
    const redirectUri = 'http://localhost:3000/linkedin-callback';
    const state = Math.random().toString(36).substring(2); // Genera un estado único

    const authURL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${encodeURIComponent('openid profile email')}`;

    // Redirige al usuario a LinkedIn
    window.location.href = authURL;
  }

  const handleLinkedInSuccess = async (code) => {
    // console.log('Código de autorización:', code); // Log para verificar que el código se recibe
    // if (!code) {
    //   console.error('No se recibió ningún código de autorización');
    //   return;
    // }

    // const redirect_uri = `${window.location.origin}/linkedin-callback`;
  
    // try {
    //   console.log("uri", redirect_uri)
    //   const { data } = await axios.post(`${apiUrl}/linkedin-auth`, { code, redirect_uri });
    //   const { access_token } = data;
  
    //   const userInfo = await axios.get('https://api.linkedin.com/v2/me', {
    //     headers: { Authorization: `Bearer ${access_token}` }
    //   });
    //   console.log('LinkedIn user info:', userInfo); // Log para verificar la respuesta de LinkedIn
  
    // } catch (error) {
    //   console.error('Error en la autenticación de LinkedIn:', error);
    // }
  };
  

  const saveUserToDatabase = async (userData) => {
    try {
      await axios.post(`${apiUrl}/collections/save-user`, userData);
      // Manejar la respuesta si es necesario
    } catch (error) {
      console.error('Error al guardar el usuario en la base de datos:', error);
    }
  };

  const sendWelcomeMail = async (email, displayName) => {
    try {
      console.log("MANDANDO MAIL DE BIENVENIDA");
      const sendWelcomeEmail = httpsCallable(functions, 'sendWelcomeEmail');

      // URL de la imagen del logo (asegúrate de que esta URL sea accesible públicamente)
      const logoUrl = 'https://reveat.pro/assets/images/RevEat_Logo_PNG.png';
      const reveatYellow = getComputedStyle(document.documentElement).getPropertyValue('--reveat-yellow').trim();

      // Plantilla HTML del correo
      const htmlContent = `
        <!DOCTYPE html>
          <html>
          <head>
              <title></title>
              <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
              <meta name="viewport" content="width=device-width, initial-scale=1">
              <meta http-equiv="X-UA-Compatible" content="IE=edge" />
              <style type="text/css">
                  @media screen {
                      @font-face {
                          font-family: 'Lato';
                          font-style: normal;
                          font-weight: 400;
                          src: local('Lato Regular'), local('Lato-Regular'), url(https://fonts.gstatic.com/s/lato/v11/qIIYRU-oROkIk8vfvxw6QvesZW2xOQ-xsNqO47m55DA.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: normal;
                          font-weight: 700;
                          src: local('Lato Bold'), local('Lato-Bold'), url(https://fonts.gstatic.com/s/lato/v11/qdgUG4U09HnJwhYI-uK18wLUuEpTyoUstqEm5AMlJo4.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: italic;
                          font-weight: 400;
                          src: local('Lato Italic'), local('Lato-Italic'), url(https://fonts.gstatic.com/s/lato/v11/RYyZNoeFgb0l7W3Vu1aSWOvvDin1pK8aKteLpeZ5c0A.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: italic;
                          font-weight: 700;
                          src: local('Lato Bold Italic'), local('Lato-BoldItalic'), url(https://fonts.gstatic.com/s/lato/v11/HkF_qI1x_noxlxhrhMQYELO3LdcAZYWl9Si6vvxL-qU.woff) format('woff');
                      }
                  }
                  body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
                  table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
                  img { -ms-interpolation-mode: bicubic; }
                  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
                  table { border-collapse: collapse !important; }
                  body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
                  a[x-apple-data-detectors] { color: inherit !important; text-decoration: none !important; font-size: inherit !important; font-family: inherit !important; font-weight: inherit !important; line-height: inherit !important; }
                  @media screen and (max-width:600px) { h1 { font-size: 32px !important; line-height: 32px !important; } }
                  div[style*="margin: 16px 0;"] { margin: 0 !important; }
              </style>
          </head>
          <body style="background-color: #f4f4f4; margin: 0 !important; padding: 0 !important;">
              <div style="display: none; font-size: 1px; color: #fefefe; line-height: 1px; font-family: 'Lato', Helvetica, Arial, sans-serif; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden;">
                  ¡Bienvenido a Reveat! Estamos encantados de tenerte con nosotros.
              </div>
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr>
                      <td align="center" style="background-color: ${reveatYellow};">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                              <tr>
                                  <td align="center" valign="top" style="padding: 40px 10px 40px 10px;">
                                  </td>
                              </tr>
                          </table>
                      </td>
                  </tr>
                  <tr>
                      <td align="center" style="padding: 0px 10px 0px 10px; background-color: ${reveatYellow};">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                              <tr>
                                  <td bgcolor="#ffffff" align="center" valign="top" style="padding: 40px 20px 20px 20px; border-radius: 4px 4px 0px 0px; color: #111111; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 48px; font-weight: 400; line-height: 48px;">
                                      <h1 style="font-size: 48px; font-weight: 400; margin: 2;">¡Bienvenido a Reveat!</h1>
                                      <img src="${logoUrl}" width="160" height="125" style="display: block; border: 0px; margin : 30px 20px 20px 20px" />
                                  </td>
                              </tr>
                          </table>
                      </td>
                  </tr>
                  <tr>
                      <td bgcolor="#f4f4f4" align="center" style="padding: 0px 10px 0px 10px;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                              <tr>
                                  <td bgcolor="#ffffff" align="left" style="padding: 20px 30px 40px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;text-align:center">
                                      <p style="margin: 0;"> Gracias por unirte a Reveat. Estamos encantados de que formes parte de nuestra comunidad. Con nuestras herramientas, podrás transformar las opiniones de tus clientes en oportunidades para mejorar tu restaurante.<br><br> Tu cuenta ha sido creada con éxito, y ahora tienes acceso a información valiosa con la que podrás brindar una experiencia culinaria excepcional y adaptada a las necesidades de tus comensales.<br><br> ¡Comienza a explorar y a hacer crecer tu negocio! </p>
                                  </td>
                              </tr>
                              <tr>
                                  <td bgcolor="#ffffff" align="left">
                                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                          <tr>
                                              <td bgcolor="#ffffff" align="center" style="padding: 20px 30px 60px 30px;">
                                                  <table border="0" cellspacing="0" cellpadding="0">
                                                      <tr>
                                                          <td align="center" style="border-radius: 20px; background-color: ${reveatYellow};"><a href="${window.location.origin}/dashboard" target="_blank" style="font-size: 20px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; text-decoration: none; padding: 15px 25px; border-radius: 20px; border: 1px solid ${reveatYellow}; display: inline-block;">Ir al Dashboard</a></td>
                                                      </tr>
                                                  </table>
                                              </td>
                                          </tr>
                                      </table>
                                  </td>
                              </tr>
                              <tr>
                                  <td bgcolor="#ffffff" align="left" style="padding: 0px 30px 20px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                      <p style="margin: 0;">Este es un correo automático. Por favor, no respondas a este mensaje.</p>
                                  </td>
                              </tr>
                              <tr>
                                  <td bgcolor="#ffffff" align="left" style="padding: 0px 30px 40px 30px; border-radius: 0px 0px 4px 4px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                      <p style="margin: 0;">Saludos,<br>El equipo de Reveat</p>
                                  </td>
                              </tr>
                          </table>
                      </td>
                  </tr>
                  <tr>
                      <td bgcolor="#f4f4f4" align="center" style="padding: 30px 10px 0px 10px;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                              <tr>
                                  <td bgcolor="#FFFFFF" align="center" style="padding: 30px 30px 30px 30px; border-radius: 4px 4px 4px 4px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                      <h2 style="font-size: 20px; font-weight: 400; color: #111111; margin: 0;">¿Necesitas ayuda?</h2>
                                      <p style="margin: 0;"><a href="${window.location.origin}/faq" target="_blank" style="color: ${reveatYellow};">Estamos aquí para ayudarte</a></p>
                                  </td>
                              </tr>
                          </table>
                      </td>
                  </tr>
              </table>
          </body>
          </html>
      `;

      const result = await sendWelcomeEmail({
        to: email,
        subject: `¡Bienvenido a REVEAT, ${displayName}!`,
        text: `Hola ${displayName}, bienvenido a REVEAT! Tu cuenta ha sido creada exitosamente.`,
        html: htmlContent
      });

      console.log('Email enviado:', result.data);
    } catch (error) {
      console.error('Error al enviar el email:', error);
    }
  };

  return (
    <div className='login-wrapper'>
    <div className='login'>
      {isLoading ? (
        <div className='loading-wrapper'>
          <LoadingScreen />
        </div>
      ) : (
        <div className="form">
          <img
            src="../assets/images/RevEat_Logo_PNG.png"
            alt="Logo"
            className="logo"
          />
          <button onClick={signInWithGoogle} className="social-button google-button">
            <FaGoogle className="social-icon" /> {t('loginGoogle')}
          </button>
          <button onClick={signInWithTwitter} className="social-button twitter-button">
            <FaTwitter className="social-icon" /> {t('loginTwitter')}
          </button>
          <button onClick={signInWithLinkedin} className="social-button linkedin-button">
            <FaLinkedinIn className="social-icon" /> {t('loginLinkedin')}
          </button>
          
        </div>
      )}
    </div>
    </div>
  );
  
};

export default Login;
